/* ==========================================================================
   SG-2026 · Cart-Drawer Remove-Handler
   --------------------------------------------------------------------------
   Faengt Klicks auf den Remove-Link (`.sg-cart-item__remove`) im Cart-Drawer
   ab, bevor der Browser dem `<a href="/cart/change?...">` folgt und zur
   Cart-Page redirected.

   Ablauf:
     1. `line-item:will-change` dispatchen  -> Pill-Loader wird aktiv
     2. Sections fuer den Bundle-Response einsammeln
        (`cart:prepare-bundled-sections`) — genauso wie das Stock-Theme
     3. POST /cart/change.js mit quantity: 0
     4. Premium-Collapse-Animation (Fade + leichtes Slide-X, dann Height 0)
     5. `cart:change` dispatchen — CartDrawer re-rendert Footer sofort
        und tauscht den Inner-Content nach 1250 ms neutral nach
     6. Bei letztem Item: Animation kurz halten, Drawer blendet dann
        selbst auf Empty-State um (Stock-Verhalten)
   ========================================================================== */

(function () {
  'use strict';

  var PREFERS_REDUCED = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Click-Delegation auf Document-Level ------------------------------- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.sg-cart-item__remove');
    if (!link) return;

    var lineEl = link.closest('line-item') || link.closest('.sg-cart-item');
    if (!lineEl) return;

    var href = link.getAttribute('href') || '';
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    var lineKey = url.searchParams.get('id');
    if (!lineKey) return;

    event.preventDefault();
    removeLineItem(lineEl, lineKey);
  }, false);

  /* --- Hauptablauf ------------------------------------------------------- */
  async function removeLineItem(lineEl, lineKey) {
    if (lineEl.dataset.sgRemoving === 'true') return;
    lineEl.dataset.sgRemoving = 'true';

    lineEl.dispatchEvent(new CustomEvent('line-item:will-change', {
      bubbles: true,
      detail: { targetQuantity: 0 }
    }));

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    var response;
    try {
      response = await fetch((window.Shopify.routes.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: sectionsToBundle
        })
      });
    } catch (e) {
      onError(lineEl);
      return;
    }

    if (!response.ok) {
      onError(lineEl);
      return;
    }

    var cart;
    try { cart = await response.json(); }
    catch (e) { onError(lineEl); return; }

    await animateRemoval(lineEl);

    if (lineEl.parentNode) lineEl.parentNode.removeChild(lineEl);

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'sg:line-item:remove',
        cart: cart
      }
    }));
  }

  function onError(lineEl) {
    lineEl.dataset.sgRemoving = '';
    lineEl.dispatchEvent(new CustomEvent('line-item:error', { bubbles: true }));
  }

  /* --- Premium Collapse-Animation --------------------------------------- *
     Phase 1 (0–220 ms): opacity 1 -> 0, translateX 0 -> 12 px
     Phase 2 (220–460 ms): height -> 0, vertikales Padding/Margin -> 0
     Insgesamt ~460 ms; das Theme wartet 1250 ms bis zur Inner-HTML-Neufassung,
     also genug Puffer.
  */
  function animateRemoval(el) {
    return new Promise(function (resolve) {
      if (PREFERS_REDUCED) {
        el.style.opacity = '0';
        setTimeout(resolve, 80);
        return;
      }

      var rect = el.getBoundingClientRect();
      var startHeight = rect.height;

      var cs = getComputedStyle(el);
      var mt = cs.marginTop;
      var mb = cs.marginBottom;
      var pt = cs.paddingTop;
      var pb = cs.paddingBottom;

      el.style.height = startHeight + 'px';
      el.style.marginTop = mt;
      el.style.marginBottom = mb;
      el.style.paddingTop = pt;
      el.style.paddingBottom = pb;
      el.style.overflow = 'hidden';
      el.style.willChange = 'opacity, transform, height, margin, padding';
      // eslint-disable-next-line no-unused-expressions
      el.offsetHeight; // force reflow

      // Phase 1 — Fade + Slide (via CSS-Variable getriggert)
      el.dataset.sgRemovingAnim = 'out';

      // Phase 2 — Collapse
      var collapseTimer = setTimeout(function () {
        el.style.transition =
          'height 220ms cubic-bezier(0.22, 1, 0.36, 1),' +
          'margin-top 220ms cubic-bezier(0.22, 1, 0.36, 1),' +
          'margin-bottom 220ms cubic-bezier(0.22, 1, 0.36, 1),' +
          'padding-top 220ms cubic-bezier(0.22, 1, 0.36, 1),' +
          'padding-bottom 220ms cubic-bezier(0.22, 1, 0.36, 1)';
        el.style.height = '0px';
        el.style.marginTop = '0px';
        el.style.marginBottom = '0px';
        el.style.paddingTop = '0px';
        el.style.paddingBottom = '0px';
      }, 220);

      var finish = setTimeout(function () {
        clearTimeout(collapseTimer);
        resolve();
      }, 460);

      // Fallback via transitionend
      el.addEventListener('transitionend', function onEnd(ev) {
        if (ev.propertyName !== 'height') return;
        el.removeEventListener('transitionend', onEnd);
        clearTimeout(finish);
        resolve();
      });
    });
  }
})();
